import React, { useState } from "react";
import { Link } from "gatsby";
import { connect } from "react-redux";

import demoText from "./demoText.js";

function Demo(props) {
  const [mouseHoverLocation, setMouseHoverLocation] = useState();

  const englishStory = demoText.english;

  const russianStory = demoText.russian;

  const { theme } = props;

  return (
    <div
      style={{ border: theme === `light` ? `1px solid #EDEBE5` : null }}
      className="bg-primary text-inverse mt-12 py-7 rounded-xl shadow-2xl overflow-hidden"
    >
      <div className="flex flex-col items-center">
        <h2 className="font-bold text-4xl tracking-wide">The Nose</h2>
        <p>By Nikolai Gogol</p>
      </div>
      <div className="mt-4 px-4">
        <div className="px-4 -mt-16 hidden sm:flex ">
          <div className="w-1/2 flex justify-center">
            <svg
              className="w-12 border rounded-full shadow-inset"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <g fillRule="evenodd">
                <g strokeWidth="1pt">
                  <path
                    fill="#bd3d44"
                    d="M0 0h972.81v39.38H0zm0 78.77h972.81v39.38H0zm0 78.77h972.81v39.38H0zm0 78.77h972.81v39.38H0zm0 78.77h972.81v39.38H0zm0 78.77h972.81v39.38H0zm0 78.77h972.81V512H0z"
                  />
                  <path
                    fill="#fff"
                    d="M0 39.38h972.81v39.39H0zm0 78.77h972.81v39.39H0zm0 78.77h972.81v39.39H0zm0 78.78h972.81v39.38H0zm0 78.77h972.81v39.38H0zm0 78.76h972.81v39.39H0z"
                  />
                </g>
                <path fill="#192f5d" d="M0 0h389.12v275.7H0z" />
                <path
                  fill="#fff"
                  d="M32.3 11.82l3.93 11.02h11.03l-9.06 6.7 3.55 10.63-9.45-6.7-8.67 6.7 3.55-10.63-9.46-6.7h11.82zm64.98 0l3.55 11.02h11.42l-9.46 6.7 3.94 10.63-9.45-6.7-9.45 6.7 3.94-10.63-9.46-6.7h11.43zm64.99 0l3.54 11.02h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.46 6.7 3.94-10.63-9.45-6.7h11.42zm64.59 0l3.94 11.02h11.02l-9.05 6.7 3.54 10.63-9.45-6.7-9.06 6.7 3.54-10.63-9.45-6.7h11.82zm64.98 0l3.55 11.02h11.42l-9.45 6.7 3.94 10.63-9.85-6.7-9.06 6.7 3.55-10.63-9.46-6.7h11.42zm64.99 0l3.54 11.02h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.45 6.7 3.93-10.63-9.45-6.7h11.42zM64.99 39.38l3.54 11.03h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.46 6.7 3.94-10.63-9.45-6.7h11.42zm64.59 0l3.94 11.03h11.02l-9.06 6.7 3.55 10.63-9.45-6.7-9.06 6.7 3.54-10.63-9.45-6.7h11.82zm64.98 0l3.55 11.03h11.42l-9.45 6.7L204 67.74l-9.45-6.7-9.45 6.7 3.94-10.63-9.45-6.7h11.42zm64.99 0l3.54 11.03h11.42l-9.45 6.7L269 67.74l-9.45-6.7-9.46 6.7 3.94-10.63-9.45-6.7H256zm64.59 0l3.94 11.03h10.63l-9.06 6.7 3.55 10.63-9.46-6.7-9.05 6.7 3.54-10.63-9.45-6.7h11.81zM32.69 66.95l3.15 11.03h11.82l-9.46 6.7 3.55 10.63-9.45-6.7-8.67 6.7 3.55-10.63-9.46-6.7h11.82zm64.6 0l3.54 11.03h11.42l-9.06 6.7 3.54 10.63-9.45-6.7-9.06 6.7 3.55-10.63-9.46-6.7h11.43zm64.98 0l3.54 11.03h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.46 6.7 3.94-10.63-9.45-6.7h11.42zm64.59 0l3.94 11.03h11.02l-9.05 6.7 3.54 10.63-9.45-6.7-9.06 6.7 3.54-10.63-9.45-6.7h11.82zm64.98 0l3.55 11.03h11.42l-9.06 6.7 3.55 10.63-9.46-6.7-9.06 6.7 3.55-10.63-9.45-6.7h11.42zm64.99 0l3.54 11.03h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.45 6.7 3.93-10.63-9.45-6.7h11.42zM64.99 94.52l3.54 11.03h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.46 6.7 3.94-10.63-9.45-6.7h11.42zm64.59 0l3.94 11.03h11.02l-9.06 6.7 3.55 10.63-9.45-6.7-9.06 6.7 3.54-10.63-9.45-6.7h11.82zm64.98 0l3.55 11.03h11.42l-9.06 6.7 3.54 10.63-9.45-6.7-9.06 6.7 3.55-10.63-9.45-6.7h11.42zm64.99 0l3.54 11.03h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.46 6.7 3.94-10.63-9.45-6.7H256zm64.59 0l3.94 11.03h10.63l-9.06 6.7 3.55 10.63-9.46-6.7-9.05 6.7 3.54-10.63-9.45-6.7h11.81zM32.69 122.1l3.15 11.03h11.82l-9.46 6.7 3.55 10.63-9.45-6.7-8.67 6.7 3.55-10.63-9.46-6.7h11.82zm64.6 0l3.54 11.03h11.42l-9.06 6.7 3.54 10.63-9.45-6.7-9.06 6.7 3.55-10.63-9.46-6.7h11.43zm64.98 0l3.54 11.03h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.46 6.7 3.94-10.63-9.45-6.7h11.42zm64.59 0l3.94 11.03h11.02l-9.05 6.7 3.54 10.63-9.45-6.7-9.06 6.7 3.54-10.63-9.45-6.7h11.82zm64.98 0l3.55 11.03h11.42l-9.06 6.7 3.55 10.63-9.46-6.7-9.06 6.7 3.55-10.63-9.45-6.7h11.42zm64.99 0l3.54 11.03h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.45 6.7 3.93-10.63-9.45-6.7h11.42zM64.99 149.66l3.54 11.03h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.46 6.7 3.94-10.63-9.45-6.7h11.42zm64.59 0l3.94 11.03h11.02l-9.06 6.7 3.55 10.63-9.45-6.7-9.06 6.7 3.54-10.63-9.45-6.7h11.82zm64.98 0l3.55 11.03h11.42l-9.06 6.7 3.54 10.63-9.45-6.7-9.06 6.7 3.55-10.63-9.45-6.7h11.42zm64.99 0l3.54 11.03h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.46 6.7 3.94-10.63-9.45-6.7H256zm64.59 0l3.94 11.03h10.63l-9.06 6.7 3.55 10.63-9.46-6.7-9.05 6.7 3.54-10.63-9.45-6.7h11.81zM32.69 177.23l3.15 11.03h11.82l-9.46 6.7 3.55 10.63-9.45-6.7-8.67 6.7 3.55-10.63-9.46-6.7h11.82zm64.6 0l3.54 11.03h11.42l-9.06 6.7 3.54 10.63-9.45-6.7-9.06 6.7 3.55-10.63-9.46-6.7h11.43zm64.98 0l3.54 11.03h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.46 6.7 3.94-10.63-9.45-6.7h11.42zm64.59 0l3.94 11.03h11.02l-9.05 6.7 3.54 10.63-9.45-6.7-9.06 6.7 3.54-10.63-9.45-6.7h11.82zm64.98 0l3.55 11.03h11.42l-9.06 6.7 3.55 10.63-9.46-6.7-9.06 6.7 3.55-10.63-9.45-6.7h11.42zm64.99 0l3.54 11.03h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.45 6.7 3.93-10.63-9.45-6.7h11.42zM64.99 204.8l3.54 11.03h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.46 6.7 3.94-10.63-9.45-6.7h11.42zm64.59 0l3.94 11.03h11.02l-9.06 6.7 3.55 10.63-9.45-6.7-9.06 6.7 3.54-10.63-9.45-6.7h11.82zm64.98 0l3.55 11.03h11.42l-9.06 6.7 3.54 10.63-9.45-6.7-9.06 6.7 3.55-10.63-9.45-6.7h11.42zm64.99 0l3.54 11.03h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.46 6.7 3.94-10.63-9.45-6.7H256zm64.59 0l3.94 11.03h10.63l-9.06 6.7 3.55 10.63-9.46-6.7-9.05 6.7 3.54-10.63-9.45-6.7h11.81zM32.69 232.37l3.15 11.03h11.82l-9.46 6.7 3.55 10.63-9.45-6.7-8.67 6.7 3.55-10.64-9.46-6.7h11.82zm64.6 0l3.54 11.03h11.42l-9.06 6.7 3.54 10.63-9.45-6.7-9.06 6.7 3.55-10.64-9.46-6.7h11.43zm64.98 0l3.54 11.03h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.46 6.7 3.94-10.64-9.45-6.7h11.42zm64.59 0l3.94 11.03h11.02l-9.05 6.7 3.54 10.63-9.45-6.7-9.06 6.7 3.54-10.64-9.45-6.7h11.82zm64.98 0l3.55 11.03h11.42l-9.06 6.7 3.55 10.63-9.46-6.7-9.06 6.7 3.55-10.64-9.45-6.7h11.42zm64.99 0l3.54 11.03h11.42l-9.45 6.7 3.94 10.63-9.45-6.7-9.45 6.7 3.93-10.64-9.45-6.7h11.42z"
                />
              </g>
            </svg>
          </div>
          <div className="w-1/2 flex justify-center">
            <svg
              className="w-12 border rounded-full shadow-inset"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <g fillRule="evenodd" strokeWidth="1pt">
                <path fill="#fff" d="M0 0h512v512H0z" />
                <path fill="#0039a6" d="M0 170.7h512V512H0z" />
                <path fill="#d52b1e" d="M0 341.3h512V512H0z" />
              </g>
            </svg>
          </div>
        </div>
        <div className="flex flex-col px-4 cursor-default">
          {englishStory.map((paragraph, index) => {
            return (
              <div key={`english-${index}`} className="flex w-full">
                <p
                  id={`english-${index}`}
                  key={index}
                  className="w-1/2 mt-4 py-1 mr-5"
                >
                  {paragraph.map((sentence) => {
                    if (sentence.sentence.includes("---")) {
                      return null;
                    }

                    return (
                      <span
                        onMouseOver={() =>
                          setMouseHoverLocation(sentence.sentenceIdentifier)
                        }
                        onMouseOut={() => setMouseHoverLocation(null)}
                        onFocus={() =>
                          setMouseHoverLocation(sentence.sentenceIdentifier)
                        }
                        onBlur={() => setMouseHoverLocation(null)}
                        key={sentence.sentenceIdentifier}
                        className={
                          mouseHoverLocation === sentence.sentenceIdentifier
                            ? "bg-highlight"
                            : null
                        }
                        tabIndex="0"
                        role="tab"
                      >
                        {sentence.sentence}{" "}
                      </span>
                    );
                  })}
                </p>

                <p
                  id={`russian-${index}`}
                  key={`russian-${index}`}
                  className="w-1/2 mt-4 py-1 ml-5"
                >
                  {russianStory[index].map((sentence) => {
                    if (sentence.sentence.includes("---")) {
                      return null;
                    }
                    return (
                      <span
                        onMouseOver={() =>
                          setMouseHoverLocation(sentence.sentenceIdentifier)
                        }
                        onMouseOut={() => setMouseHoverLocation(null)}
                        onFocus={() =>
                          setMouseHoverLocation(sentence.sentenceIdentifier)
                        }
                        onBlur={() => setMouseHoverLocation(null)}
                        key={sentence.sentenceIdentifier}
                        className={
                          mouseHoverLocation === sentence.sentenceIdentifier
                            ? "bg-highlight"
                            : null
                        }
                        role="tab"
                        tabIndex="0"
                      >
                        {sentence.sentence}{" "}
                      </span>
                    );
                  })}
                </p>
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex justify-center mt-6">
        <Link to="stories/the-nose">
          <button className="flex items-center p-4 my-2 hover:bg-indigo-600 rounded-lg shadow-lg uppercase tracking-wide bg-indigo-700 text-white font-sans">
            Read the full story
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="h-6 w-6 ml-2 fill-current"
            >
              <circle
                cx={12}
                cy={12}
                r={10}
                className="fill-current text-indigo-100"
              />
              <path
                className="fill-current text-indigo-700"
                d="M14.59 13H7a1 1 0 0 1 0-2h7.59l-2.3-2.3a1 1 0 1 1 1.42-1.4l4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.42-1.4l2.3-2.3z"
              />
            </svg>
          </button>
        </Link>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  theme: state.appearance.theme,
});

export default connect(mapStateToProps, {})(Demo);
